"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processEmail = void 0;
const helpers_1 = require("../../helpers");
const agents_1 = require("../agents");
const orders_1 = require("../orders");
const getOrderToEmailObject_1 = require("../orders/getOrderToEmailObject");
const payments_1 = require("../payments");
const users_1 = require("../users");
const getEmailRecipient_1 = require("./getEmailRecipient");
const getTemplate_1 = require("./getTemplate");
const replaceTokens_1 = require("./replaceTokens");
const Mustache = require("mustache");
const processEmail = async (supabase, email) => {
    //console.log(`New Email Request: ${JSON.stringify(email)}`);
    const template = await (0, getTemplate_1.getTemplate)(supabase, email.template_id, email.language_code);
    if (!template) {
        return {
            status: 500,
            jsonBody: {
                success: false,
                message: `TEMPLATE NOT FOUND - ${email.template_id}`,
            },
        };
    }
    let data = null;
    if (email?.order_id) {
        //console.log("HAS ORDER ID");
        const order_obj = await (0, orders_1.getOrderById)(supabase, email.order_id);
        const exchange_rates = await (0, payments_1.getExchangeRates)(supabase);
        data = (0, getOrderToEmailObject_1.getOrderToEmailObject)(order_obj, email.order_line_id, exchange_rates || []);
    }
    else {
        //console.log("NO ORDER ID");
    }
    // get agent by id if set...
    if (data?.supplier?.id) {
        //console.log(`Supplier ID: ${data?.supplier?.id}`);
        // if a supplier, make default agent the Golfsavers Agent
        const agent = await (0, agents_1.getAgentById)(supabase, "b789a205-a58a-4384-ad79-f216be3e266e");
        data = { ...data, ...{ agent: agent } };
        //console.log(`Agent: ${JSON.stringify(agent)}`);
    }
    if (!data?.client) {
        const client = await (0, users_1.getUserBasicInfoByEmail)(supabase, email?.email_address || "");
        data = { ...data, ...{ client: client } };
    }
    // merge the inbound email.data with the order data
    if (email.data) {
        // merge the inbound data with the order data
        //console.log(`Merging data: ${JSON.stringify(email.data)}`);
        data = { ...data, ...email.data };
    }
    //console.log("SNIPPET", template.snippet);
    let merged_template = helpers_1.BASE_EMAIL_TEMPLATE.replace("{{body_content}}", template.html);
    merged_template = merged_template.replace("{{snippet}}", template.snippet);
    const html = Mustache.render(merged_template, {
        ...data,
        ...{
            copyright_year: new Date().getFullYear(),
        },
    });
    // const client_template = template.category === "Client";
    const email_log = {
        client_id: data?.client?.id,
        order_id: data?.order?.id || null,
        supplier_id: data?.supplier?.id || null,
        data: data,
        html: html,
        subject: (0, replaceTokens_1.replaceTokens)(template.subject, data),
        status: "pending",
        open_date: null,
        delivery_date: null,
        processed_date: null,
        agent_id: email?.agent_id || data?.agent?.id || null,
        template_id: email.template_id,
        to_address: email?.email_address || (0, getEmailRecipient_1.getEmailRecipient)(data, template),
        original_request: email,
        cc_address: email?.cc_address || null,
    };
    if (!template) {
        return {
            status: 500,
            jsonBody: {
                success: false,
                message: "SUPABASE ERROR",
            },
        };
    }
    await supabase.from("email_log").insert(email_log);
};
exports.processEmail = processEmail;
